module.exports = __webpack_public_path__ + "img/google.1e4ae617.svg";